import React from 'react';
import { Link } from 'react-router-dom';
import { Flower2, ArrowRight, CalendarDays } from 'lucide-react';
import Reveal from './Reveal';
import { MONTHS } from '../pages/SeasonalFlowersPage';

export const BloomingNow = () => {
  const m = MONTHS[new Date().getMonth()];
  return (
    <section data-testid="blooming-now-section" className="py-16 lg:py-20" style={{ backgroundColor: '#2E3A32' }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="grid lg:grid-cols-[1fr_auto] gap-8 items-center">
            <div>
              <p className="flex items-center gap-2 text-[13px] tracking-[0.2em] uppercase font-medium" style={{ color: m.color }}>
                <CalendarDays className="w-4 h-4" /> Blooming now · {m.name}
              </p>
              <h2 className="mt-3 font-serif-display text-base md:text-lg text-[#F7F3EB] max-w-2xl leading-snug">
                What’s in season this month
              </h2>
              <div className="mt-4 flex flex-wrap gap-2">
                {m.blooms.map((b) => (
                  <span key={b} data-testid={`bloom-pill-${b.toLowerCase().replace(/[^a-z]+/g, '-')}`} className="inline-flex items-center gap-1.5 rounded-full border border-[#F7F3EB]/25 px-3.5 py-1.5 text-sm text-[#F7F3EB]/90">
                    <Flower2 className="w-3.5 h-3.5" style={{ color: m.color }} /> {b}
                  </span>
                ))}
              </div>
              <p className="mt-4 text-[15px] text-[#F7F3EB]/70 max-w-2xl leading-relaxed">{m.note}</p>
            </div>
            <Link
              to="/seasonal-flowers"
              data-testid="seasonal-calendar-link"
              className="group inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[15px] font-medium transition-colors duration-200"
              style={{ backgroundColor: '#C4715A', color: '#FDFBF6' }}
            >
              See the full flower calendar
              <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default BloomingNow;
